import { render, staticRenderFns } from "./QuarterlyMarketSwitch.vue?vue&type=template&id=3c86d47a&scoped=true"
import script from "./QuarterlyMarketSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./QuarterlyMarketSwitch.vue?vue&type=script&setup=true&lang=js"
import style0 from "./QuarterlyMarketSwitch.vue?vue&type=style&index=0&id=3c86d47a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c86d47a",
  null
  
)

export default component.exports